// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3r4F1","name":"ConsentHeader_name___W-Sl","birthday":"ConsentHeader_birthday__3f9yl","skeleton":"ConsentHeader_skeleton__CmFdC"};